














import { defineComponent } from '~/utils/nuxt3-migration'
import { defineComponentTranslations } from '~/utils/i18n'

export default defineComponent({
  i18n: defineComponentTranslations({
    weak_pass_alert: {
      en:
        'Your password is considered weak. Please change it soon to protect your account',
      el:
        'Ο κωδικός σου θεωρείται αδύναμος. Κάνε αλλαγή κωδικού σύντομα για να προστατεύσεις τον λογαριασμό σου.'
    }
  })
})
